module["exports"] = [
  "np",
  "com",
  "info",
  "net",
  "org"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/nep/internet/domain_suffix.js
 ** module id = 865
 ** module chunks = 0
 **/